import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, InstagramIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const handleEmailContact = () => {
    window.open('mailto:bhavinisapra4@gmail.com?subject=Reaching%20out%20from%20your%20portfolio', '_blank');
  };
  return <footer className="bg-gray-900 text-white py-8" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-112">
          <div className="mb-4 md:mb-0" data-id="element-113">
            <Link to="/" className="text-xl font-bold text-white" data-id="element-114">
              Bhavini Sapra
            </Link>
            <p className="text-indigo-200 text-sm mt-1" data-id="element-115">
              Product Manager with a passion for solving real-world problems
            </p>
          </div>
          <div className="flex space-x-4" data-id="element-116">
            <a href="https://www.linkedin.com/in/bhavinisapra/" target="_blank" rel="noopener noreferrer" className="text-indigo-300 hover:text-white transition-colors" aria-label="LinkedIn Profile" data-id="element-117">
              <LinkedinIcon className="h-6 w-6" data-id="element-118" />
            </a>
            <button onClick={handleEmailContact} className="text-indigo-300 hover:text-white transition-colors" aria-label="Email Contact" data-id="element-119">
              <MailIcon className="h-6 w-6" data-id="element-120" />
            </button>
            <a href="https://www.instagram.com/growthwithbhavini/" target="_blank" rel="noopener noreferrer" className="text-indigo-300 hover:text-white transition-colors" aria-label="Instagram Profile" data-id="element-121">
              <InstagramIcon className="h-6 w-6" data-id="element-122" />
            </a>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-4 flex flex-col md:flex-row justify-between items-center" data-id="element-123">
          <p className="text-sm text-indigo-200" data-id="element-124">
            © {currentYear} Bhavini Sapra. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-125">
            <nav className="flex space-x-4 text-sm" data-id="element-126">
              <Link to="/" className="text-indigo-300 hover:text-white transition-colors" data-id="element-127">
                Home
              </Link>
              <Link to="/my-story" className="text-indigo-300 hover:text-white transition-colors" data-id="element-128">
                About Me
              </Link>
              <Link to="/contact" className="text-indigo-300 hover:text-white transition-colors" data-id="element-129">
                Contact
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;